import GroupIcon from "@mui/icons-material/Group";
import CategoryIcon from "@mui/icons-material/Category";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import WarningIcon from "@mui/icons-material/Warning";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import {
    Person,
    ProductionQuantityLimits,
    PropaneRounded,
    RoomSharp,
    ShoppingCart,
} from "@mui/icons-material";

// Nav groups: each group has a translation key and a list of items.
// groupKey / textKey are looked up via t() in the NavGroup component.
// allowedUsers: employee type IDs that can see the item.
const MenuRoutes = [
    {
        groupKey: "NAV_SALES",
        items: [
            {
                route: "/AddSale",
                textKey: "CREATE_SALE",
                icon: <PointOfSaleIcon />,
                allowedUsers: [1, 2, 3],
            },
            {
                route: "/SalesList",
                textKey: "NAV_SALES_LIST",
                icon: <ReceiptIcon />,
                allowedUsers: [1, 2, 3],
            },
        ],
    },
    {
        groupKey: "NAV_INVENTORY",
        items: [
            {
                route: "/ItemList",
                textKey: "NAV_ITEMS",
                icon: <CategoryIcon />,
                allowedUsers: [1, 2, 3],
            },
            {
                route: "/StockLocationList",
                textKey: "STOCK_LOCATIONS",
                icon: <RoomSharp />,
                allowedUsers: [1, 2],
            },
            {
                route: "/AddBuyInvoice",
                textKey: "NEW_PURCHASE",
                icon: <ShoppingCart />,
                allowedUsers: [1, 2],
            },
            {
                route: "/BuyInvoices",
                textKey: "PURCHASES",
                icon: <PropaneRounded />,
                allowedUsers: [1, 2],
            },
        ],
    },
    {
        groupKey: "NAV_CUSTOMERS",
        items: [
            {
                route: "/CustomerList",
                textKey: "OTHER_PARTIES",
                icon: <GroupIcon />,
                allowedUsers: [1, 2, 3],
            },
            {
                route: "/customer-reports",
                textKey: "REPORTS",
                icon: <PeopleIcon />,
                allowedUsers: [1, 2, 3],
            },
        ],
    },
    {
        groupKey: "NAV_FINANCE",
        items: [
            {
                route: "/Expenses",
                textKey: "EXPENSES",
                icon: <AddBusinessIcon />,
                allowedUsers: [1, 2, 3],
            },
            {
                route: "/unpaid-invoices",
                textKey: "UNPAID_INVOICES",
                icon: <WarningIcon />,
                allowedUsers: [1, 2, 3],
            },
            {
                route: "/daily-report",
                textKey: "DAILY_REPORT",
                icon: <BarChartIcon />,
                allowedUsers: [1, 2],
            },
        ],
    },
    {
        groupKey: "NAV_ALERTS",
        items: [
            {
                route: "/items-below-min-quantity",
                textKey: "ITEMS_BELOW_MIN",
                icon: <ProductionQuantityLimits />,
                allowedUsers: [1, 2, 3],
            },
            {
                route: "/items-expiring-soon",
                textKey: "EXPIRING_SOON",
                icon: <WarningIcon />,
                allowedUsers: [1, 2, 3],
            },
        ],
    },
    {
        groupKey: "NAV_ADMIN",
        items: [
            {
                route: "/Users",
                textKey: "USERS",
                icon: <Person />,
                allowedUsers: [1, 2],
            },
        ],
    },
];

export default MenuRoutes;
